import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import Spinner from '../../components/common/Spinner';
import { validateEmail } from '../../helpers/helperFunctions';
import { AuthLayoutTitle, Button } from '../../styles/GlobalComponents';
import { sendResetPasswordEmail } from './ForgottenPassword.actions';

const captchaId = process.env.REACT_APP_CAPTCHA_ID;

const ForgottenPassword = () => {
  const { t } = useTranslation('onboarding');
  const [id, setId] = useState('');
  const digit = /^\d+$/;

  const dispatch = useAppDispatch();

  const { loading } = useAppSelector((state) => state.auth);

  const [captchaLoading, setCaptchaLoading] = useState(false);

  const sendMail = (e: any) => {
    e.preventDefault();

    setCaptchaLoading(true);

    window.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const result = captcha.getValidate();
            if (validateEmail(id)) {
              dispatch(sendResetPasswordEmail({ id, type: 1, result }));
            } else if (id.match(digit)) {
              dispatch(sendResetPasswordEmail({ id, type: 2, result }));
            } else {
              dispatch(sendResetPasswordEmail({ id, type: 3, result }));
            }
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}
      {captchaLoading && <Spinner fullScreen={true} transparent />}

      <AuthLayoutTitle>{t('forgotten_password.title')}</AuthLayoutTitle>
      {/* <Label>{t('forgotten_password.label')}</Label> */}
      <form onSubmit={sendMail}>
        <InputBackOffice
          id={'id'}
          type={'text'}
          placeholder={t('forgotten_password.placeholder')}
          name={'id'}
          value={id}
          onChange={setId}
          label={t('forgotten_password.label')}
        />

        <Button
          m='30px 0 10px 0'
          type='submit'
          disabled={id === '' ? true : false}>
          {t('forgotten_password.buttonText')}
        </Button>
      </form>
    </>
  );
};

export default ForgottenPassword;
